<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>
          {{ $t('docSignerList') }}
          <v-spacer></v-spacer>
          <v-text-field id="9ab5ad44" v-model="search" :label="$t('search')" append-icon="mdi-magnify" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          id="13b9cb69"
          must-sort
          :search="search"
          :headers="headers"
          :items="docSignerList"
          :options.sync="pagination"
          :server-items-length="totalItems"
          :loading="loading"
          :loading-text="$t('dataTable.loadingPleaseWait')"
          :no-data-text="$t('dataTable.noDataAvailable')"
          :no-results-text="$t('dataTable.noMatchingRecordsFound')"
          :footer-props="{
            'items-per-page-text': $t('dataFooter.itemsPerPage'),
            'page-text': $t('dataFooter.pageText'),
            'items-per-page-options': [10,25,50]
          }"
        >
          <template v-if="isMOBILSIGN" v-slot:item.keyStoreName="{ item }">
            <span v-if="item.keyStoreName">{{ item.keyStoreName }}</span>
            <v-icon v-else color="grey">{{ 'mdi-minus-circle' }}</v-icon>
          </template>
          <template v-slot:item.keyStoreActivated="{ item }">
            <v-icon v-if="!isMOBILSIGN" :color="item.keyStoreActivated ? 'green' : 'red'">{{ item.keyStoreActivated ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
            <v-icon v-else :color="item.keyStoreName ? item.keyStoreActivated ? 'green' : 'red' : 'grey'">
              {{ item.keyStoreName ? item.keyStoreActivated ? 'mdi-check-circle' : 'mdi-close-circle' : 'mdi-minus-circle' }}
            </v-icon>
          </template>
          <template v-if="isAdmin" v-slot:item.action="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn :id="setTableItemOperationDynamicId('481d28c5', item.name)" icon :to="'docSigners/' + item.name + '/update'" v-on="on">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('update') }}</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn :id="setTableItemOperationDynamicId('684ded2f', item.name)" icon v-on="on" @click="deleteDocSigner(item.name, !!item.keyStoreName)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('delete') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <fab-button v-if="isAdmin" id="4c0357fd" tooltip-text="add" to="docSigners/add" />
    </v-flex>
  </v-layout>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapGetters } from 'vuex'
import Feature from '../../Feature'
import Role from '../../Role'
import signers from '../../api/signers'
import FabButton from '../../components/FabButton.vue'
import { showToastSuccess, showToastError, showConfirmationDialog } from '../../event-bus'

export default {
  name: 'DocSignerList',

  components: {
    'fab-button': FabButton
  },

  data() {
    return {
      search: null,
      pagination: {
        sortBy: ['name']
      },
      docSignerList: [],
      totalItems: 0,
      loading: false,
      headers: [
        {
          text: this.$t('name'),
          align: 'left',
          value: 'name'
        },
        {
          text: this.$t('keyStoreName'),
          value: 'keyStoreName',
          sortable: false
        },
        {
          text: this.$t('keyStoreActivated'),
          value: 'keyStoreActivated',
          sortable: false
        },
        {
          text: this.$t('actions'),
          value: 'action',
          sortable: false
        }
      ]
    }
  },

  computed: {
    ...mapGetters(['hasRole']),
    isAdmin() {
      return this.hasRole(Role.ADMIN)
    },
    ...mapGetters(['hasFeatures']),
    isMOBILSIGN() {
      return this.hasFeatures(Feature.MOBILSIGN)
    }
  },

  watch: {
    search() {
      this.loading = true
      this.searchDocSignerWatcher()
    },

    pagination() {
      this.searchDocSigners()
    }
  },

  methods: {
    async searchDocSigners() {
      this.loading = true
      try {
        let pageRequest = {
          'page-num': this.pagination.page,
          'page-size': this.pagination.itemsPerPage,
          'sort-field': this.pagination.sortBy[0],
          'sort-order': this.pagination.sortDesc[0] ? 'desc' : 'asc'
        }
        let page = await signers.listDocSigners(this.search, pageRequest)
        this.docSignerList = page.content
        this.totalItems = page.total
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      } finally {
        this.loading = false
      }
    },

    searchDocSignerWatcher: debounce(function() {
      this.searchDocSigners()
    }, 500),

    async deleteDocSigner(name, isExistKeyStoreName) {
      let conf = await showConfirmationDialog(this.$t('confirmation'), this.$t('dialog.text.deleteItem'), isExistKeyStoreName, this.$t('dialog.text.deleteItemKey'))
      if (!conf.confirmedValue) {
        return
      }

      try {
        await signers.deleteDocSigner(name, isExistKeyStoreName ? conf.confirmedCheckboxValue : false)
        this.searchDocSigners()
        showToastSuccess(this.$t('toastMessage.succesfullyDeleted'))
      } catch (error) {
        let errorMsg = this.$t('toastMessage.errorWhileRetrievingData')
        if (error.response != null) {
          switch (error.response.data.code) {
            case 'STILL_REFERENCED':
              errorMsg = this.$t('toastMessage.stillReferenced', { param: 'DocSigner', param2: 'keyAlias' })
              break
            case 'GENERAL':
              errorMsg = '(' + error.response.data.code + ')' + ' ' + error.response.data.message
          }
        }
        showToastError(errorMsg)
      }
    }
  }
}
</script>
